import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import Overview from '../../pages/issuer/Fundraise/Overview';
import DataRoom from '../../pages/issuer/Fundraise/DataRoom';
import Templates from '../../pages/issuer/Fundraise/Templates';
import VerifiedPartners from '../../pages/issuer/Fundraise/VerifiedPartners';
import FundingOptions from '../../pages/issuer/Fundraise/FundingOptions';
//import Offerings from '../../pages/issuer/Fundraise/Offerings';
import RegisteredInterests from '../../pages/issuer/Dashboard/RegisteredInterests';
import VerticalContainer from '../../components/VerticalContainer';

const FundraiseRoutes = () => {
    let { path } = useRouteMatch();

    return (
        <VerticalContainer>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}/`} component={Overview} />
                    <Route
                        exact
                        path={`${path}/data-room`}
                        component={DataRoom}
                    />
                    <Route
                        exact
                        path={`${path}/templates`}
                        component={Templates}
                    />
                    <Route
                        exact
                        path={`${path}/verified-partners`}
                        component={VerifiedPartners}
                    />
                    <Route
                        exact
                        path={`${path}/funding-options`}
                        component={FundingOptions}
                    />
                    <Route
                        exact
                        path={`${path}/registered-interests`}
                        component={RegisteredInterests}
                    />
                    {/*<Route
                        exact
                        path={`${path}/offerings`}
                        component={Offerings}
                    />*/}
                </Switch>
            </TabPanel>
        </VerticalContainer>
    );
};

export default FundraiseRoutes;
